module.exports = __webpack_public_path__ + "img/upload.c3e3fdc7.svg";